var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Project } from '@/models/Project';
import { Template as TemplateModel } from '@/models/Template';
import ErrorHandler from '@/support/ErrorHandler';
import { quilEditorOptionsModules } from '@/support/QuilEditorOptions';
import { sanitizeString } from '@/support/String';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Template from './Template';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
let Templates = class Templates extends Vue {
    constructor() {
        super(...arguments);
        this.templates = [];
        this.newTemplate = new TemplateModel({ value: '' });
        this.fileName = '';
        this.isStoring = false;
        this.isUploading = false;
        this.setToDefault = false;
        this.isShowingDialog = false;
        this.fileInput = null;
    }
    get editorOptions() {
        return {
            placeholder: this.$t('template.placeholder'),
            modules: quilEditorOptionsModules,
        };
    }
    mounted() {
        if (this.project.exists()) {
        }
        this.initialize();
    }
    async initialize() {
        await new TemplateModel()
            .project(this.project)
            .all()
            .then((templates) => {
            templates.forEach((template, index) => {
                template.attachment = false;
                templates[index] = template;
            });
            this.templates = templates;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    handleTemplateRemoved(template) {
        if (!template.id) {
            return;
        }
        const index = this.findById(template.id);
        this.templates.splice(index, 1);
    }
    clear() {
        this.newTemplate = new TemplateModel();
        this.fileName = '';
    }
    store() {
        if (!this.newTemplate.value) {
            return;
        }
        if (this.setToDefault) {
            this.newTemplate.is_default = 1;
        }
        else {
            this.newTemplate.is_default = 0;
        }
        this.isStoring = true;
        this.newTemplate
            .project(this.project)
            .create()
            .then((template) => {
            template.attachment = false;
            this.templates.push(template);
            this.isStoring = false;
            this.handleTemplateAdded(template.id);
            this.setToDefault = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isStoring = false;
        });
        this.newTemplate.value = '';
    }
    setDefault() {
        if (this.setToDefault) {
            this.setToDefault = false;
        }
        else {
            this.setToDefault = true;
        }
    }
    inputChanged(event, template) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        if (template) {
            template.file = files[0];
        }
        else {
            this.newTemplate.file = files[0];
        }
        this.fileName = files[0].name;
    }
    findById(id) {
        return this.templates.findIndex((template) => template.id === id);
    }
    async handleTemplateUpdated(templateId) {
        await this.initialize();
        this.resetTemplateClone(templateId);
    }
    async handleTemplateAdded(templateId) {
        await this.initialize();
        this.resetTemplateClone(templateId);
    }
    resetTemplateClone(templateId) {
        Object.keys(this.$refs).forEach((ref) => {
            if (this.$refs[ref][0]) {
                if (ref !== templateId) {
                    this.$refs[ref][0].initialize();
                }
            }
        });
    }
    openFileInput() {
        const input = document.getElementById('uploadFile');
        if (input) {
            input.click();
        }
    }
    sanitizeString(value) {
        return sanitizeString(value, true);
    }
};
__decorate([
    Prop({ default: new Project() }),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Templates.prototype, "project", void 0);
Templates = __decorate([
    Component({
        components: {
            AQuillEditor,
            'template-row': Template,
        },
    })
], Templates);
export default Templates;
